"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var react_1 = __importDefault(require("react"));

function requireIcon(icon) {
  switch (icon) {
    case "close":
      {
        return require("../assets/images/bb8-close.svg");
      }

    case "pinned":
      {
        return require("../assets/images/bb8-pinned.svg");
      }

    default:
      return;
  }
}

var styles = core_1.createStyles(function (theme) {
  return {
    root: {
      height: "44px",
      width: "44px"
    }
  };
});

var BB8IconButton = function BB8IconButton(props) {
  var icon = props.icon,
      classes = props.classes,
      others = __rest(props, ["icon", "classes"]);

  var iconElement = requireIcon(icon);
  return react_1.default.createElement(core_1.IconButton, __assign({}, others, {
    className: classes.root
  }), react_1.default.createElement("img", {
    src: iconElement
  }));
};

exports.default = core_1.withStyles(styles)(BB8IconButton);